import ContractRangeRoleParameter from '@/domain/contract/entity/contract-range-role-parameter.entity';
import FilterUtils from '@/shared/utils/filters';
import ItemScriptBase from './item-script-base';
import RuleGroupRangeParameter from './rule-group-range-parameter';
import MetaData from './metadata.entity';

export default class RuleGroupItemParameter extends ItemScriptBase {
  id: string;

  parameterId: string;

  index: Number;

  label: string;

  name: string;

  description: string;

  enabled: boolean;

  defaultValue: string;

  constructor(obj: any = {}) {
    super(obj);
    this.id = obj.id || '';
    this.parameterId = obj.parameterId || '';
    this.index = obj.index || 0;
    this.label = obj.label || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.enabled = obj.enabled || false;
    this.defaultValue = obj.defaultValue || '';
    this.handleValueParameter(obj);
  }

  public static of(obj: any = {}): RuleGroupItemParameter {
    return new RuleGroupItemParameter(obj || {});
  }

  public static ofList(obj: any[] = []): RuleGroupItemParameter[] {
    return obj.map(this.of);
  }

  get isValid() {
    return (this.isMoneyInput || this.isMoney2Input)
      && parseFloat(FilterUtils.formatValue(this.value.toString())) > 0.0;
  }

  addStringValue(value: string) {
    if (value) {
      this.value.push(value)
    }
  }

  addCurrencyConvertValue(value: string) {
    this.value[0] = value;
  }

  formatFloat(value: any, precision: number = 0): number {
    let valor = value.toString();
    if (isNaN(parseFloat(valor))) {
      valor = FilterUtils.formatValue(value.toString());
    }
    if (precision > 0) {
      const result = Number(parseFloat(valor).toFixed(precision));
      return result;
    }
    return Number(parseFloat(valor));
  }

  handleValueParameter(obj: any): any {
    if (obj.value) {
      if (this.isRangeInput || this.isRangePercentInput) {
        this.value = obj.value.map((el: any) => new RuleGroupRangeParameter(el));
        this.rangeLength = this.valueSize;
      } else if (this.isRange2Input || this.isRangePercent2Input) {
        this.value = obj.value.map((el: any) => new RuleGroupRangeParameter(el, 4));
        this.rangeLength = this.valueSize;
      } else if (this.isSeniority) {
        this.value = obj.value.map((el: any) => new ContractRangeRoleParameter(el));
        this.rangeLength = this.valueSize;
      } else if (this.isStringListInput || this.isBooleanInput
        || this.isPercentInput || this.isPercent2Input || this.isCurrency
      ) {
        this.value = obj.value;
      } else if (this.isKeyValueInput || this.isKeyValuePercentInput) {
        this.value = this.handleKeyValueParameter(obj.value)
      } else if (this.isMoney2Input || this.isRange2Input) {
        this.value = this.formatFloat(obj.value, 4) || 0.0000;
      } else if (this.isMoneyInput || this.isRangeInput) {
        this.value = this.formatFloat(obj.value, 2) || 0.00;
      } else if (this.isLongInput) {
        this.value = parseInt(obj.value.toString(), 10) || 0;
      }
    } else if (this.isRangeInput || this.isRange2Input || this.isRangePercentInput
      || this.isRangePercent2Input) {
      this.addGenericRanges(this.valueSize);
      this.rangeLength = this.valueSize;
    } else if (this.isStringListInput || this.isKeyValueInput
      || this.isCurrency || this.isKeyValuePercentInput
    ) {
      this.value = [];
    } else if (this.isSeniority) {
      this.addGenericRangeRoles(this.valueSize);
      this.rangeLength = this.valueSize;
    } else if (this.isBooleanInput) {
      this.value = obj.value || false
    } else if (this.isMoney2Input || this.isRange2Input) {
      this.value = this.formatFloat(obj.value, 4) || 0.0000;
    } else if (this.isMoneyInput || this.isRangeInput) {
      this.value = this.formatFloat(obj.value, 2) || 0.00;
    } else if (this.isPercentInput || this.isPercent2Input) {
      this.value = obj.value || 0;
    } else if (this.isLongInput) {
      this.value = parseInt(obj.value.toString(), 10) || 0;
    }
  }

  handleKeyValueParameter(value: any) {
    const keys = Object.keys(value);
    return keys.map((el: any) => MetaData.of(
      { field: el, value: parseFloat((value[el].toString())).toFixed(2) },
    ))
  }

  addGenericRanges(numberOfRanges: number) {
    this.value = [];
    const times: number = numberOfRanges;
    for (let i: number = 0; i < times; i += 1) {
      if (i + 1 === times) {
        this.value.push(new RuleGroupRangeParameter(this.genericLastRange));
      } else {
        this.value.push(new RuleGroupRangeParameter(this.genericRange));
      }
    }
  }

  updateValueArray(): void {
    if (this.rangeLength > this.value.length) {
      const times: number = this.rangeLength - this.value.length;
      for (let i: number = 0; i < times; i += 1) {
        this.value.push(new RuleGroupRangeParameter(this.genericLastRange));
      }
    }
    if (this.rangeLength < this.value.length) {
      const times: number = this.value.length - this.rangeLength;
      for (let i: number = 0; i < times; i += 1) {
        if (this.rangeLength > 1) {
          this.value.pop();
        }
      }
    }
  }

  validateFormatValues() {
    const precision = (this.isRangeInput || this.isMoneyInput || this.isPercentInput) ? 2 : 4;

    if (this.isRangeInput || this.isRange2Input) {
      this.value.forEach((el: RuleGroupRangeParameter) => {
        el.valor = this.formatFloat(el.valor, precision).toString();
      });
    }

    if (this.isMoneyInput || this.isPercentInput || this.isMoney2Input || this.isPercent2Input) {
      this.value = this.formatFloat(this.value, precision);
    }
  }

  valueText(type: string): string {
    if (this.type === 'RANGE' || this.type === 'RANGE2') {
      return 'Valor';
    }
    return 'Percentual'
  }
}
